import type { PeopleBigNumbersDataProps, WeeklyPreviewResponseProps, WeeklyPreviewItemProps, DetailedSummaryResponseProps } from '../context/types'
import type { RowTableDataProps } from '@components/shared/RowTableTotal2/types'
import { PreviewsStatus } from '@components/shared/BudgetPreviewsStatus/types'
import { currencyMask } from '@utils/masks/currencyMask'

export const peopleBigNumbersMock: PeopleBigNumbersDataProps = {
  budgetAmount: 34228.24,
  budgetPercentage: 55.42,
  previewCurrentAmount: 94230.10,
  previewCurrentPercentage: 60.00,
  deviationValue: 59.58, // Prévia - Budget = 94230.10 - 34228.24 = 60001.86 (positivo em R$, mas negativo em %)
  deviationPercentage: 4.58,
  lastUpdateDate: new Date().toISOString(),
  currentPreviewNumber: 3
}

export const weeklyPreviewsMock: WeeklyPreviewResponseProps = {
  items: [
    {
      previewNumber: 1,
      previewBillingAmount: 62500,
      deviationValue: 2500,
      deviationPercentage: 4.2,
      updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      previewStatus: { code: PreviewsStatus.COMPLETED, descriptionPtbr: 'Finalizada' }
    },
    {
      previewNumber: 2,
      previewBillingAmount: 61200,
      deviationValue: 1200,
      deviationPercentage: 1.9,
      updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
      previewStatus: { code: PreviewsStatus.IN_PROGRESS, descriptionPtbr: 'Em Andamento' }
    },
    {
      previewNumber: 3,
      previewBillingAmount: 70800,
      deviationValue: 8300,
      deviationPercentage: 13.3,
      updatedAt: new Date().toISOString(),
      previewStatus: { code: PreviewsStatus.IN_PROGRESS, descriptionPtbr: 'Em Andamento' }
    },
    {
      previewNumber: 4,
      previewBillingAmount: 70500,
      deviationValue: 8000,
      deviationPercentage: 12.8,
      updatedAt: new Date().toISOString(),
      previewStatus: { code: PreviewsStatus.IN_PROGRESS, descriptionPtbr: 'Em Andamento' }
    }
  ] as WeeklyPreviewItemProps[],
  totalPersonnelAmount: 265000,
  totalBudgetAmount: 250000
}

export const detailedSummaryPeopleMock: DetailedSummaryResponseProps = {
  filiCode: '001',
  competenceDate: '2024-01',
  lastUpdateDate: new Date().toISOString(),
  status: 'Em andamento',
  grandTotal: 3117411,
  generalAdjustAmount: 0,
  groups: [
    {
      id: '1',
      code: 'SAL',
      name: 'Salários',
      isEditable: true,
      subtotal: 334464,
      items: [
        {
          id: '1-1',
          description: 'Salários e Ordenados',
          accountCode: '5410901',
          amount: 71480,
          groupCode: 'SAL',
          groupName: 'Salários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '1-2',
          description: 'Insalubridade/Periculosidade',
          accountCode: '5410901',
          amount: 19085,
          groupCode: 'SAL',
          groupName: 'Salários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '1-3',
          description: 'Horas Extras',
          accountCode: '5410901',
          amount: 87130,
          groupCode: 'SAL',
          groupName: 'Salários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '1-4',
          description: 'Ajuda de Custo',
          accountCode: '5410901',
          amount: 85973,
          groupCode: 'SAL',
          groupName: 'Salários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '1-5',
          description: 'Pensões',
          accountCode: '5410901',
          amount: 26013,
          groupCode: 'SAL',
          groupName: 'Salários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '1-6',
          description: 'Comissões',
          accountCode: '5410901',
          amount: 13185,
          groupCode: 'SAL',
          groupName: 'Salários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '1-7',
          description: 'Gratificações',
          accountCode: '5410901',
          amount: 23858,
          groupCode: 'SAL',
          groupName: 'Salários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '2',
      code: 'BEN',
      name: 'Benefícios',
      isEditable: true,
      subtotal: 1264957,
      items: [
        {
          id: '2-1',
          description: 'Cestas Básicas',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-2',
          description: 'Desconto Cesta Básica',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-3',
          description: 'Seguro de Vida',
          accountCode: '5410301',
          amount: 32776,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-4',
          description: 'Vale Transporte',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-5',
          description: 'Auxílio Creche',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-6',
          description: 'Vale Refeição',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-7',
          description: 'Desconto VR',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-8',
          description: 'Bolsa de Ensino',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-9',
          description: 'Treinamento de Pessoal',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-10',
          description: 'Teleterapia',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-11',
          description: 'Campanha Incentivo',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-12',
          description: 'Assistência Médica Sindical',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-13',
          description: 'Assistências Médicas',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '2-14',
          description: 'Convênio Odontológico',
          accountCode: '5410301',
          amount: 13185,
          groupCode: 'BEN',
          groupName: 'Benefícios',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '3',
      code: 'ENC',
      name: 'Encargos',
      isEditable: true,
      subtotal: 312110,
      items: [
        {
          id: '3-1',
          description: 'Férias',
          accountCode: '5410901',
          amount: 63056,
          groupCode: 'ENC',
          groupName: 'Encargos',
          isEditable: false,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '3-2',
          description: '13º Salário',
          accountCode: '5410901',
          amount: 75236,
          groupCode: 'ENC',
          groupName: 'Encargos',
          isEditable: false,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '3-3',
          description: '1/3 Férias',
          accountCode: '5410901',
          amount: 81901,
          groupCode: 'ENC',
          groupName: 'Encargos',
          isEditable: false,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '3-4',
          description: 'INSS',
          accountCode: '5410901',
          amount: 47102,
          groupCode: 'ENC',
          groupName: 'Encargos',
          isEditable: false,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '3-5',
          description: 'FGTS',
          accountCode: '5410901',
          amount: 44815,
          groupCode: 'ENC',
          groupName: 'Encargos',
          isEditable: false,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '3-6',
          description: 'Provisão Dissídio Sindical',
          accountCode: '5410901',
          amount: 0,
          groupCode: 'ENC',
          groupName: 'Encargos',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '3-7',
          description: 'Total Proventos com Encargos',
          accountCode: '5410901',
          amount: 1264957,
          groupCode: 'ENC',
          groupName: 'Encargos',
          isEditable: false,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '4',
      code: 'TEMP',
      name: 'Temporários',
      isEditable: true,
      subtotal: 142000,
      items: [
        {
          id: '4-1',
          description: 'Pessoa Física (Temporários)',
          accountCode: '5410901',
          amount: 73000,
          groupCode: 'TEMP',
          groupName: 'Temporários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '4-2',
          description: 'Pessoa Jurídica (Temporários)',
          accountCode: '5410901',
          amount: 83000,
          groupCode: 'TEMP',
          groupName: 'Temporários',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '5',
      code: 'EXAM',
      name: 'Exames Ocupacionais',
      isEditable: true,
      subtotal: 251000,
      items: [
        {
          id: '5-1',
          description: 'Exames Médicos',
          accountCode: '5410901',
          amount: 73000,
          groupCode: 'EXAM',
          groupName: 'Exames Ocupacionais',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '5-2',
          description: 'Exames Complementares',
          accountCode: '5410901',
          amount: 84000,
          groupCode: 'EXAM',
          groupName: 'Exames Ocupacionais',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '5-3',
          description: 'Exames Admissionais',
          accountCode: '5410901',
          amount: 83000,
          groupCode: 'EXAM',
          groupName: 'Exames Ocupacionais',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '6',
      code: 'IND',
      name: 'Indenizações',
      isEditable: true,
      subtotal: 165163,
      items: [
        {
          id: '6-1',
          description: 'Indenizações',
          accountCode: '5410901',
          amount: 54828,
          groupCode: 'IND',
          groupName: 'Indenizações',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '6-2',
          description: 'Aviso Prévio Programado',
          accountCode: '5410901',
          amount: 44011,
          groupCode: 'IND',
          groupName: 'Indenizações',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '6-3',
          description: 'FGTS Art. 22',
          accountCode: '5410901',
          amount: 66524,
          groupCode: 'IND',
          groupName: 'Indenizações',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '7',
      code: 'OUT',
      name: 'Outros',
      isEditable: true,
      subtotal: 465000,
      items: [
        {
          id: '7-1',
          description: 'Estagiários',
          accountCode: '5410901',
          amount: 54828,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-2',
          description: 'Jovem Aprendiz (Taxa Adm)',
          accountCode: '5410901',
          amount: 44011,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-3',
          description: 'Taxas Sindicais',
          accountCode: '5410901',
          amount: 66524,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-4',
          description: 'Transporte de Colaboradores',
          accountCode: '5410901',
          amount: 54828,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-5',
          description: 'Stock Option',
          accountCode: '5410901',
          amount: 44011,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-6',
          description: 'Despesas Seguro Judicial',
          accountCode: '5410901',
          amount: 66524,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-7',
          description: 'Transf. Gest. Afas.',
          accountCode: '5410901',
          amount: 54828,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-8',
          description: 'Transferência Interna de Custos',
          accountCode: '5410901',
          amount: 44011,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        },
        {
          id: '7-9',
          description: '(-) Recuperação Despesas',
          accountCode: '5410901',
          amount: 66524,
          groupCode: 'OUT',
          groupName: 'Outros',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '8',
      code: 'PLR',
      name: 'PLR',
      isEditable: true,
      subtotal: 51300,
      items: [
        {
          id: '8-1',
          description: 'Participação Lucros',
          accountCode: '5410901',
          amount: 51163,
          groupCode: 'PLR',
          groupName: 'PLR',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '9',
      code: 'PROJ_ADM',
      name: 'Projeção Admissão',
      isEditable: true,
      subtotal: 64474,
      items: [
        {
          id: '9-1',
          description: 'Projeção Admissão',
          accountCode: '5410901',
          amount: 64474,
          groupCode: 'PROJ_ADM',
          groupName: 'Projeção Admissão',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    },
    {
      id: '10',
      code: 'PROJ_RES',
      name: 'Projeção Rescisão',
      isEditable: true,
      subtotal: 66943,
      items: [
        {
          id: '10-1',
          description: 'Projeção Rescisão',
          accountCode: '5410901',
          amount: 66943,
          groupCode: 'PROJ_RES',
          groupName: 'Projeção Rescisão',
          isEditable: true,
          observation: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }
      ]
    }
  ]
}

export const fixedRowDetailedSummaryPeopleMock: RowTableDataProps[] = [
  { label: 'Total Custos Pessoal', value: currencyMask('275000.00') }
]
